import React, { useState } from 'react'
import { Box, Flex, Text, Image, Link } from '@theme-ui/components'
import moment from 'moment'
import { nanoid } from 'nanoid'
import generateLink from '../../../helpers/generateLink'
import checkIfExternalLink from '../../../helpers/checkIfExternalLink'
import Lightbox from 'react-image-lightbox'
import cloudinaryString from '../../../helpers/cloudinaryString'
import AnimationSelector from '../../Animation/AnimationSelector'

export default function Shout({ shoutData, variantName, options, locationIndex, ...rest }) {
  const [lightBox, setLightbox] = useState({
    isOpen: false
  })

  const { containerStyles, animation } = options
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  return (
    <>
      {shoutData ? (
        <AnimationSelector animation={animation}>
          <Flex variant={`${variantName}.container`} sx={styles} className="container shoutContainer">
            <Text variant={`${variantName}.title`} as="h3" className="title">
              Recent Shout
            </Text>
            <Text variant={`${variantName}.date`} className="date">
              {moment(shoutData.shout.createdAt).format('MMMM DD, YYYY, hh:mm a')}
            </Text>
            <Text variant={`${variantName}.text`} className="text">
              {shoutData.shout.text}
            </Text>
            {shoutData?.shout?.ctas ? (
              <Flex variant={`${variantName}.shoutCTAS`} className="shoutCTABtns">
                {Object.keys(shoutData.shout.ctas).map(ctaName => {
                  if (ctaName === 'cta1' || ctaName === 'cta2') {
                    return ''
                  } else {
                    return (
                      <Link
                        key={nanoid()}
                        variant={`${variantName}.shoutCTA`}
                        href={generateLink(shoutData.shout.ctas[ctaName])}
                        target={checkIfExternalLink(shoutData.shout.ctas[ctaName]) ? '_blank' : ''}
                      >
                        {ctaName}
                      </Link>
                    )
                  }
                })}
              </Flex>
            ) : (
              ''
            )}

            {!shoutData.shout.image.isDefault && (
              <Flex variant={`${variantName}.imageContainer`} className="imageContainer">
                <Box variant={`${variantName}.imageFill`} className="imageFill" />
                <Image
                  className="image"
                  src={cloudinaryString(
                    'https://res.cloudinary.com/gonation/',
                    shoutData.shout.image.image.cloudinaryId,
                    600
                  )}
                  onClick={() => {
                    setLightbox({
                      isOpen: true
                    })
                  }}
                  alt="Shout_Display"
                />
              </Flex>
            )}
          </Flex>
        </AnimationSelector>
      ) : (
        ''
      )}

      {lightBox.isOpen && (
        <Lightbox
          reactModalStyle={{ content: { zIndex: '5000' } }}
          mainSrc={shoutData.imageBaseUrl + '/' + shoutData.shout.image.image.cloudinaryId}
          onCloseRequest={() => setLightbox({ isOpen: false })}
        />
      )}
    </>
  )
}
